/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GrantPK
 */
export interface GrantPK {
    /**
     * User Id
     * @type {string}
     * @memberof GrantPK
     */
    userId?: string;
    /**
     * User's role in the org
     * @type {string}
     * @memberof GrantPK
     */
    grant?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof GrantPK
     */
    orgId?: string;
}

/**
 * Check if a given object implements the GrantPK interface.
 */
export function instanceOfGrantPK(value: object): boolean {
    return true;
}

export function GrantPKFromJSON(json: any): GrantPK {
    return GrantPKFromJSONTyped(json, false);
}

export function GrantPKFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantPK {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'grant': json['grant'] == null ? undefined : json['grant'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
    };
}

export function GrantPKToJSON(value?: GrantPK | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'grant': value['grant'],
        'orgId': value['orgId'],
    };
}

